import AnalyticManager, {
  AnalyticsItem,
} from '~/services/analytics/AnalyticManager';
import Amplitude from '~/services/analytics/vendors/Amplitude';
import GoogleTagManagerDataLayer from '~/services/analytics/vendors/GoogleTagManagerDataLayer';
import MicrosoftClarity from '~/services/analytics/vendors/MicrosoftClarity';
import localStorage from '~/services/storage/localStorage';

const analyticsSubscribers: Array<AnalyticsItem> = [];

const AMPLITUDE_API_KEY = process.env.AMPLITUDE_API_KEY || null;

if (AMPLITUDE_API_KEY) {
  analyticsSubscribers.push(new Amplitude(AMPLITUDE_API_KEY));
}

analyticsSubscribers.push(new MicrosoftClarity());
analyticsSubscribers.push(new GoogleTagManagerDataLayer());

const analyticsManager = new AnalyticManager(
  analyticsSubscribers,
  localStorage,
);

export default analyticsManager;
